import { render, staticRenderFns } from "./GradeSelectModal.vue?vue&type=template&id=81c243a8"
import script from "./GradeSelectModal.ts?vue&type=script&lang=ts&external"
export * from "./GradeSelectModal.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports